import { render, staticRenderFns } from "./MFADialog.vue?vue&type=template&id=5e0f9c18"
import script from "./MFADialog.vue?vue&type=script&lang=ts"
export * from "./MFADialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports